// extracted by mini-css-extract-plugin
export default {"listItem":"_4TsT3t6uG1qFshsjG11ajV","link":"_7el00JOQLMzPmAPd5gDcT3"};